import { CardPerformanceDataContainer as MetricItem } from '../../insight/models/card-performance-data-container.model';
import { ColourGroup } from '../models/colour-group.model';

export function extractMetrics(colourGroups: ColourGroup[]): MetricItem[] {
    return colourGroups?.reduce<MetricItem[]>((acc, group) => {
        if (group.metrics != null) {
            acc.push(...group.metrics);
        }
        return acc;
    }, []);
}
